export type FormStateKey = 'autoPersonalForm' | 'homePersonalForm';

export type BinderFormStateKey = FormStateKey | 'commercialForm';

export const STEP_THREE_CONFIG: Record<
  FormStateKey,
  {
    title: string;
    successMessage: string;
    disabledMessage: string;
    resendSuccessMessage: string;
  }
> = {
  autoPersonalForm: {
    title: 'MPOI & COI',
    successMessage: 'MPOI & COI has been issued',
    disabledMessage: 'Sign documents to enable MPOI & COI generation',
    resendSuccessMessage: 'COI and MPOI will be sent to broker shortly',
  },
  homePersonalForm: {
    title: 'COI',
    successMessage: 'COI has been issued',
    disabledMessage: 'Sign documents to enable COI generation',
    resendSuccessMessage: 'COI will be sent to broker shortly',
  },
};
